// Player ability registry (Fase 3).

import type { World } from './world';
import type { InputFrame } from './input';
import type { SceneCmd } from '../render/scene';

export interface Ability {
  id: string;
  name: string;
  gemCost?: number;
  cooldownMs: number;
  onCharge?(world: World, input: InputFrame): void;
  onRelease?(world: World, input: InputFrame): void;
  onTick?(world: World, dt: number): void;
  render?(world: World): SceneCmd[];
  isUnlocked?(world: World): boolean;
}

const registry = new Map<string, Ability>();

export function registerAbility(a: Ability): void {
  registry.set(a.id, a);
}

export function getAbility(id: string): Ability | undefined {
  return registry.get(id);
}

export function listAbilities(): Ability[] {
  return [...registry.values()];
}

export function clearAbilities(): void {
  registry.clear();
}
